import { create } from "zustand";

const stencilWeekStore = create((set) => ({
  stencilWeeks: [],

  setStencilWeeks: (data) => set({ stencilWeeks: data }),

  reset: () => {
    set({ stencilWeeks: [] });
  },
}));

export default stencilWeekStore;
